import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Prefix } from '@interfaces/prefix';

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    const hasUpperCase = /[A-Z]+/.test(value);
    const hasLowerCase = /[a-z]+/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    const hasNumber = /[0-9]+/.test(value);
    const isValid = hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;
    return isValid ? null : {
      passwordStrength: {
        hasUpperCase,
        hasLowerCase,
        hasNumber,
        hasSpecialChar,
      }
    };
  };
}


export function passwordsMatchValidator(passwordControlName: string, confirmPasswordControlName: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const passwordControl = control.get(passwordControlName);
    const confirmPasswordControl = control.get(confirmPasswordControlName);

    if (!passwordControl || !confirmPasswordControl) {
      return null;
    }
    if (confirmPasswordControl.errors && !confirmPasswordControl.errors['passwordMismatch']) {
      return null;
    }

    if (passwordControl.value !== confirmPasswordControl.value) {
      confirmPasswordControl.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    } else {
      if (confirmPasswordControl.errors && confirmPasswordControl.errors['passwordMismatch']) {
        const newErrors = { ...confirmPasswordControl.errors };
        delete newErrors['passwordMismatch'];
        confirmPasswordControl.setErrors(Object.keys(newErrors).length > 0 ? newErrors : null);
      }
      return null;
    }
  };
}

export function emailFormatValidator(control: AbstractControl): ValidationErrors | null {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (control.value && !emailRegex.test(control.value)) {
    return { 'invalidEmailFormat': true };
  }
  return null;
}

export function fileTypeValidator(allowedTypes: string[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const file = control.value as File;
    if (file && !allowedTypes.includes(file.type)) {
      return { 'invalidFileType': { value: control.value } };
    }
    return null;
  };
}

export function fileSizeValidator(maxSizeBytes: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const file = control.value as File;
    if (file && file.size > maxSizeBytes) {
      return { 'invalidFileSize': { value: control.value } };
    }
    return null;
  };
}


const PHONE_REGEX = /^[0-9]{6,15}$/;
export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    return PHONE_REGEX.test(control.value) ? null : { 'invalidPhone': 'invalid_phone' };
  };
}
